import React, { useContext } from "react";
import { Form, Input, Typography, Row, Col, Button } from "antd";
import { useFormLayout } from "./../../Utils/Hooks/useFormLayout";
import { appContext } from "../../AppContext";
import { Card } from "./../../library/src/";
import { useTranslation } from "react-i18next";
import { CheckCircleOutlined, SendOutlined } from "@ant-design/icons";
//hooks
import { useNotification } from "./../../Utils/Hooks/useNotification";
import { useFetch } from "../../Utils/Hooks/useFetch";

const size = "large";

export default function CoreUserCard({
  currentUser: propsCurrentUser,
  originalUser: propsOriginalUser,
  setCurrentUser: propsSetCurrentUser,
  isRefresh: propsIsRefresh,
  save: propsSave,
}) {
  const layout = useFormLayout(size, "horizontal");
  const [appState] = useContext(appContext);
  const [createNotification, NotificationType] = useNotification();
  const [doFetch, FetchType] = useFetch();
  const { t } = useTranslation(["user", "utils"]);

  const FormLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    labelAlign: "left",
    colon: false,
    hideRequiredMark: true,
  };

  // function verifyMailStatus() {
  //   return (
  //     <>
  //       {propsCurrentUser.emailValidated ? (
  //         <Tag icon={<CheckCircleOutlined />} color="success">
  //           {t("user.emailVerified")}
  //         </Tag>
  //       ) : (
  //         <Tag icon={<ExclamationCircleOutlined />} color="warning">
  //           {t("user.emailNotVerified")}
  //         </Tag>
  //       )}
  //     </>
  //   );
  // }

  function onClickEmailVerification() {
    propsSave();
    doFetch(
      `/Email/SendEmailValidationMail/${propsCurrentUser.id}`,
      FetchType.POST
    ).then((response) => {
      if (response.isSuccess) {
        createNotification(
          NotificationType.SUCCESS,
          t("notifications.sendEmailSuccess.title"),
          t("notifications.sendEmailSuccess.message")
        );

        propsIsRefresh(true);
        return;
      }

      createNotification(
        NotificationType.ERROR,
        t("notifications.sendEmailFailure.title"),
        t("notifications.sendEmailFailure.message")
      );
    });
  }

  return (
    <Card title={t("coreDataTitle")} marginBottom>
      <Form {...FormLayout} name="basic" className="form-large">
        <Form.Item label={t("user.userName")} name="username">
          <Typography.Text>{propsCurrentUser.userName}</Typography.Text>
        </Form.Item>

        <Form.Item label={t("user.name")} name="person">
          <Typography.Text>{propsCurrentUser.person.summary}</Typography.Text>
        </Form.Item>

        <Form.Item label={t("user.email")} name="email">
          <Row style={{ flexWrap: "nowrap" }}>
            <Input
              defaultValue={propsCurrentUser.email}
              onChange={(e) => {
                let newUser = JSON.parse(JSON.stringify(propsCurrentUser));
                newUser.email = e.target.value;
                propsSetCurrentUser(newUser);
              }}
              disabled={!appState.user.isAdministrator}
            />
            <Button
              onClick={() => onClickEmailVerification()}
              style={{ marginLeft: 16 }}
              disabled={
                propsCurrentUser.emailValidated ||
                propsCurrentUser.email === "" ||
                JSON.stringify(propsOriginalUser) ===
                  JSON.stringify(propsCurrentUser)
              }
              icon={
                propsCurrentUser.emailValidated ? (
                  <CheckCircleOutlined />
                ) : (
                  <SendOutlined />
                )
              }
            >
              {propsCurrentUser.emailValidated
                ? t("user.emailVerified")
                : t("user.emailVerify")}
            </Button>
          </Row>
        </Form.Item>
      </Form>
    </Card>
  );
}
